import { render, staticRenderFns } from "./Pin-File.vue?vue&type=template&id=07107659&"
import script from "./Pin-File.vue?vue&type=script&lang=js&"
export * from "./Pin-File.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports